import { CompactUserResponse } from '../account';
import { ChannelId } from '../SupportChannel';

export type CannedId = string;

export enum CannedResponseType {
  email = 'email',
  support = 'support',
  proposal = 'proposal',
  project = 'project',
  subscription = 'subscription',
}

export interface CannedResponse {
  id: CannedId;
  name: string;
  content: string;
  isPrivate: boolean;
  channels: ChannelId[];
  user: CompactUserResponse;
  canEdit: boolean;
  type: CannedResponseType;
}
